const memberFullName = (m: { firstName: string; lastName: string }) => [m.firstName, m.lastName].join(' ').trim();

export const UNKNOWN_MEMBER = {
  firstName: 'Unknown',
  lastName: 'member',
  get displayName() {
    return memberFullName({ firstName: this.firstName, lastName: this.lastName });
  },
} as const;

export const DELETED_MEMBER_NAME = 'Deleted member';
